import React, { FC } from 'react'

import Layout, { LayoutProps } from '../../layouts/Layout'
import { ActionButtonProps } from '../../components/ActionButton'
import { TextareaProps } from '../../components/form/Textarea'

import * as SC from './styled'

export type ConfirmationTemplateProps = {
  className?: string
  layoutProps?: LayoutProps
  title?: string
  text?: string
  textarea: TextareaProps
  back?: {
    label: string
    onClick?: () => void
  }
  confirmButton: ActionButtonProps
}

const ConfirmationTemplate: FC<ConfirmationTemplateProps> = ({
  layoutProps,
  title,
  text,
  back,
  confirmButton,
}) => {
  return (
    <Layout {...layoutProps}>
      <SC.Content>
        <SC.Box>
          <SC.Title>{title}</SC.Title>
          <SC.Text>{text}</SC.Text>
          <SC.Divider />
          <SC.Buttons>
            {back && <SC.Back onClick={back.onClick}>{back.label}</SC.Back>}
            <SC.ConfirmButton {...confirmButton} />
          </SC.Buttons>
        </SC.Box>
      </SC.Content>
    </Layout>
  )
}

export default ConfirmationTemplate
